export default {
      id: "collapse-usage",
      viewBox: "0 0 22.002 21",
      url: __webpack_public_path__ + "img/icons.svg#collapse",
      toString: function () {
        return this.url;
      }
    }